import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from './textarea.scss';

class Textarea extends React.PureComponent {
  render() {
    // eslint-disable-next-line no-unused-vars
    const { className, ...props } = this.props;

    return <textarea {...props} className={this.styles.textarea} />;
  }

  styles = {
    textarea: classNames(styles.textarea, this.props.className),
  };
}

Textarea.propTypes = {
  className: PropTypes.string,
};

export default Textarea;
